import React, { Component } from 'react'
import { connect } from 'react-redux'
import Redirect from './Redirect'

import { doLoginSuccess } from '../actions'
import { envConstants } from '../constants'

const initialState = {
  redirect: false
}

class Validate extends Component {
  constructor() {
    super()
    this.state = initialState
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.auth.valid && !this.props.auth.valid) {
      this.setState({ redirect: true })
    }
  }

  componentWillMount() {
    const bearer = window.localStorage.getItem(envConstants.ls.bearer)
    if (bearer !== undefined && bearer !== null) {
      this.props.doLoginSuccess({
        bearer,
        time: window.localStorage.getItem(envConstants.ls.time),
        email: window.localStorage.getItem(envConstants.ls.email)
        // role: window.localStorage.getItem(envConstants.ls.bearer)
      })
    } else {
      if (window.location.pathname !== '/') {
        this.setState({ redirect: true })
      }
    }
  }

  render() {
    return <div>{this.state.redirect && <Redirect to='/' />}</div>
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { doLoginSuccess })(Validate)
